import Vue from 'vue';
import uppercase from '~/lib/uppercase';

export default Vue.filter('uppercase', value => uppercase(value));
